import { useMainStore } from '~/store'

export const useMapData = async () => {
  const store = useMainStore()
  const mapData = ref(null)
  const isLoading = ref(true)
  const error = ref(null)

  try {
    const mapResponse = await $fetch(`${store.baseURL}/mapplic`)
    const processedStores = store.processedStores || []

    const storeMap = {}
    processedStores.forEach(store => {
      storeMap[store.id] = store
    })

    // Enrich each level
    const enrichedLevels = await Promise.all(
      mapResponse.levels.map(async level => {
        const enrichedLocations = await Promise.all(
          level.locations.map(async loc => {
            const matchedStore = storeMap[loc.store_id]

            if (matchedStore && matchedStore.slug) {
              const todaysHours = matchedStore.hours || null

              return {
                ...loc,
                path: `/store-directory/${matchedStore.slug}`,
                store: {
                  ...matchedStore
                },
                hours: todaysHours
              }
            }

            return {
              ...loc,
              store: matchedStore || null,
              hours: null
            }
          })
        )

        return {
          ...level,
          locations: enrichedLocations
        }
      })
    )

    mapData.value = {
      ...mapResponse,
      levels: enrichedLevels
    }
  } catch (err) {
    console.error('Failed to fetch or enrich map data:', err)
    error.value = err
  } finally {
    isLoading.value = false
  }

  return { mapData, isLoading, error }
}
